<template>
    <div class="container nopadding">
        <div class="wrapper login">
            <h1 class="white text-center"><b>{{$t('account.accedi_dati')}}</b></h1>
            <div class="content mt-3">
                <form>
                    <div class="form-group">
                        <input type="text" class="form-control"
                               :placeholder="$t('account.nome_utente')+' *'"
                               v-model="form.account">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control"
                               :placeholder="$t('password').capitalize()+' *'"
                               v-model="form.password"
                               autocomplete>
                    </div>
                    <router-link :to="{name:'user.password.remember'}">
                        <i>{{$t('account.password.dimenticata')}}?</i>
                    </router-link>
                    <br><br>
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary"
                                style="min-width:230px;"
                                @click.prevent="handleLogin(form)"
                                :disabled="this.loading_visible">
                            {{$t(('account.accedi'))}}
                        </button>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-12 d-flex align-items-center justify-content-center mb-3 mb-sm-0">
                            <button type="button" class="btn btn-light btn-outline-dark" style="padding: .5rem 1rem;"
                                    @click="handleGoogleSignIn()">
                                <div class="d-flex justify-content-between align-items-center">
                                    <i class="fab fa-google"></i>
                                    &nbsp;&nbsp;
                                    <span style="text-transform: none;">
                                        {{$t('continua_con_google')}}
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br>
        <div class="text-center">
            <router-link :to="{name:'user.registration'}">
                <button type="button" class="btn btn-trasp" style="min-width:230px;">
                    {{$t('account.no_registrato')}}?
                </button>
            </router-link>
        </div>
        <br>
        <div class="text-center" v-if="this.order_type === 'ORDINA_TAVOLO'">
            <button type="button" class="btn btn-trasp" style="min-width:230px;" @click="this.onContinueAsGuest">
                {{$t('account.prosegui_ospite')}}
            </button>
        </div>
        <br>
        <br>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {login} from '../../api/account';

import ModalErrors from '../partials/ModalErrors';

export default {
    name: "Login",
    components: {ModalErrors},
    data: function () {
        return {
            form: {
                account: '',
                password: ''
            }
        }
    },
    mounted() {
    },
    computed: {
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('order', {
            order_type: state => state.type
        })
    },
    methods: {
        handleLogin: function (params, post_callback = null, error_callback = null) {
            this.showLoading(true);

            login(this.language, Object.assign({}, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id
            }, params)).then((response) => {
                this.postLogin(response);
            }).catch(({messages, data, fromEndpoint}) => {
                if (fromEndpoint && error_callback) {
                    error_callback(data);
                } else if (messages) {
                    this.showModalErrors({
                        title: 'ACCOUNT',
                        errors: messages
                    });
                }
            }).finally(() => {
                if (post_callback) {
                    post_callback();
                }
                this.showLoading(false);
            })
        },
        postLogin: function (response) {
            this.saveUserData({
                api_key: response.api_key,
                language: response.cod_lingua,
                email: response.account
            });

            if (this.language !== response.cod_lingua) {
                this.setLanguage(response.cod_lingua);
            }

            switch (this.$route.query.back) {
                case 'cart':
                    this.$router.replace({name: 'cart'});
                    break;
                default:
                    this.$router.replace({name: 'home'});
                    break;
            }
        },
        handleGoogleSignIn: function () {
            this.$gAuth.signIn().then((googleUser) => {
                const profile = googleUser.getBasicProfile();

                this.handleLogin({
                    google_id_token: googleUser.getAuthResponse().id_token,
                }, () => {
                    this.$gAuth.signOut().catch(() => {
                        alert("Google Sign Out Error.");
                    });
                }, (data) => {
                    if (data.status === 'KUOKKO_EMAIL_NOT_FOUND') {
                        this.$router.replace({
                            name: 'user.registration',
                            query: {
                                email: profile.getEmail(),
                                nome: profile.getGivenName(),
                                cognome: profile.getFamilyName()
                            }
                        });
                    } else if (data.status === "GOOGLE_ERROR") {
                        alert("Google error");
                    }
                });
            }).catch((e) => {
            });
        },
        onContinueAsGuest: function () {
            this.$router.replace({name: 'cart.summary', query: {guest: '1'}});
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
        ...mapActions('localization', [
            'setLanguage'
        ]),
        ...mapActions('auth', [
            'saveUserData'
        ]),
    }
}
</script>
